const createErrorResult = (errorMessage = '') => ({
  hasError: true,
  errorMessage,
});

const createNoErrorResult = () => ({
  hasError: false,
});

export const prepareError = (error) => {
  if (typeof error === 'boolean' && error) {
    return createErrorResult();
  }

  if (Array.isArray(error) && error.length > 0) {
    return createErrorResult(error.join());
  }

  if (typeof error === 'string' && error.length > 0) {
    return createErrorResult(error);
  }

  return createNoErrorResult();
};
